import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';

const TransporterDropdownEditor = forwardRef((props, ref) => {
  const [value, setValue] = useState(props.value || "");
  const selectRef = useRef(null);

  useEffect(() => {
    selectRef.current?.focus();
  }, []);

  // Expose getValue to AG Grid
  useImperativeHandle(ref, () => ({
    getValue: () => value
  }));

  return (
    <select
      ref={selectRef}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      className='tpt-dropdown-style'
     
    >
      {props.colDef.cellEditorParams?.values?.map((option, idx) => (
        <option key={idx} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
});

export default TransporterDropdownEditor;
